'use strict';exports.__esModule = true;exports.default =

extractLocalisedData;var _constants = require('../constants');function extractLocalisedData(localisationObject, locale) {
  return localisationObject[locale] || localisationObject[_constants.language.fallback];
}module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/extractLocalisedData.js
// module id = 393
// module chunks = 0